module.exports = __webpack_public_path__ + "img/timetable-nostu.be42be29.png";